import Markdown from "markdown-to-jsx";

import { Separator } from "@/components/ui/separator";
import {
  Anchor,
  Blockquote,
  H2,
  H3,
  H4,
  InlineCode,
  ListItem,
  P,
  UnorderedList,
} from "@/components/ui/typography";

export function MarkdownRenderer({
  children,
  className,
}: {
  children: string;
  className?: string;
}) {
  return (
    <Markdown
      options={{
        overrides: {
          ul: UnorderedList,
          a: Anchor,
          li: ListItem,
          hr: Separator,
          h1: H2,
          h2: H3,
          h3: H4,
          blockquote: Blockquote,
          code: InlineCode,
          p: (props) => <P {...props} className="my-4 first:mt-0 last:mb-0" />,
          em: (node: { children: string[] }) => {
            const firstChild = node.children[0];

            if (firstChild?.startsWith("~") && firstChild.endsWith("~")) {
              return (
                <span className="underline">{firstChild.slice(1, -1)}</span>
              );
            }

            return <em>{node.children[0]}</em>;
          },
        },
      }}
      className={className}
    >
      {children}
    </Markdown>
  );
}
